import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import DemoFormB2B from '../../components/site/Forms/DemoFormB2B'
import DemoForm from '../../components/site/Forms/DemoForm'

import './CardFooter.scss'

const CardTrialNew = ({ className = '', contaAzul, page = '', text, children, isEcommerce = false, isReps, partnerId, radius, ctaText, horizontalCard, trialText, modalLink, inlineBtns, modalSmall, ctaBtn }) => (
    <section className={`trial-background new-box-trial-wrapper ${horizontalCard ? 'new-trial-horizontal' : ''} ${className ? className : ''}`}>
        <div className={cx('box-trial', page)}>
            <div className='container text-center'>

                {
                    isEcommerce
                        ? (<h5 className='card-trial-title'>{text}</h5>)
                        : (<h2 className='card-trial-title'>{text}</h2>)
                }

                {
                    isEcommerce
                        ?
                        <DemoFormB2B>{ctaText}</DemoFormB2B>
                        : ctaBtn
                            ?
                            ctaBtn
                            :
                            isReps
                                ?
                                <DemoForm darkBg />
                                :
                                <DemoForm trialAndDemo={trialText ? trialText : 'teste grátis'} darkBg ctaText modalLink={modalLink ? true : false} showOr={horizontalCard ? true : false} inlineBtns={inlineBtns ? true : false} modalSmall={modalSmall ? true : false} />

                }
            </div>
        </div>
    </section>
)

CardTrialNew.propTypes = {
    children: PropTypes.node,
    contaAzul: PropTypes.bool,
    page: PropTypes.string,
    partnerId: PropTypes.string,
    radius: PropTypes.string,
}

CardTrialNew.defaultProps = {
    contaAzul: false,
    partnerId: '',
    text: <Fragment>Junte-se a mais de 8 mil clientes<br /> que estão potencializando vendas</Fragment>
}

export default CardTrialNew



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardFooter/CardTrialv2.jsx